module.exports = __webpack_public_path__ + "img/blue1.2c7d0b89.jpg";